export interface VendorUser{
  companyUserId?: number;
  username?: string;
  emailAddress?: string;
  vendorNumber?: string;
}

export function isVendorUser(arg: any): arg is VendorUser {
  return arg && arg.companyUserId;
}

